'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _geolocationStyles = require('./geolocationStyles.scss');

var _geolocationStyles2 = _interopRequireDefault(_geolocationStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocatorGeolocation = (_dec = (0, _reactCssModules2.default)(_geolocationStyles2.default), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(PickupLocatorGeolocation, _React$Component);

  function PickupLocatorGeolocation() {
    (0, _classCallCheck3.default)(this, PickupLocatorGeolocation);
    return (0, _possibleConstructorReturn3.default)(this, (PickupLocatorGeolocation.__proto__ || (0, _getPrototypeOf2.default)(PickupLocatorGeolocation)).apply(this, arguments));
  }

  (0, _createClass3.default)(PickupLocatorGeolocation, [{
    key: 'onClick',
    value: function onClick(e) {
      e.preventDefault();

      navigator.geolocation.getCurrentPosition(this.getLocation.bind(this), this.onError.bind(this));
    }
  }, {
    key: 'onError',
    value: function onError() {
      this.props.gpsUnavailable();
    }
  }, {
    key: 'getLocation',
    value: function getLocation(data) {
      if (!data || !data.coords) return;

      var coords = data.coords;


      this.props.search(coords);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.canUseGps) return _react2.default.createElement('span', null);

      return _react2.default.createElement(
        'div',
        { styleName: 'geolocation', onClick: this.onClick.bind(this) },
        this.props.children
      );
    }
  }]);
  return PickupLocatorGeolocation;
}(_react2.default.Component)) || _class);
exports.default = PickupLocatorGeolocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Geolocation/index.js
// module id = 553
// module chunks = 0